module.exports = "/_next/static/images/OgSegmentVsMparticle-aacd251772bdbe6e07d60e8a87cbed65.png";